export default __webpack_public_path__ + "b9770a9ea54da5dbf0ce17148c942407.png";